export interface MaintenanceRequestCreatePayload {
  asset_id: string | number;
  request_date: string;
  form_template_id?: string | number;

  // Maintenance Details (Tab 3)
  request_type?: string;
  issue_type?: string;
  issue_description?: string;
  priority?: string;
  issue_photos?: string;
  is_critical?: boolean;

  custom_fields?: Record<string, any>;
  [key: string]: any;
}

export interface MaintenanceRequestFulfillmentPayload {
  assign_request_to: string;
  // In-House
  assign_to_user_id?: string | number;
  assign_to_user_name?: string;
  department?: string;
  expected_start_date?: string;
  expected_resolution_date?: string;
  // Vendor
  vendor_name?: string;
  contact_person?: string;
  contact_number?: string;
  covered_under?: string;
  estimated_repair_cost?: number;
  need_to_send_out?: boolean;
  send_to_location?: string;
  dispatch_date?: string;
  expected_return_date?: string;
  transport_mode?: string;
  pickup_challan?: string;
}

export interface MaintenanceRequestWorkDetailPayload {
  // In-house
  initial_diagnosis?: string;
  is_asset_operational?: boolean;
  is_vendor_likely_required?: boolean;
  request_to_discard?: boolean;
  // Vendor
  return_fixed_date?: string;
  return_mode?: string;
  delivery_challan?: string;
  maintenance_status?: string;
  vendor_notes?: string;
  pi?: string;
  claim_no?: string;
  amount?: number;
  asset_condition?: string;
  functional_test_done?: boolean;
  // Common
  parts_replaced?: boolean;
}

export interface MaintenanceRequestPartItemPayload {
  id?: string | number;
  part_id?: string | number;
  part_name?: string;
  part_serial_no?: string;
  warranty_on_part?: string;
  remarks?: string;
  is_deleted?: boolean;
  custom_fields?: Record<string, any>;
}

export interface MaintenanceRequestUpdatePayload {
  type_of_request?: string;
  issue_type?: string;
  description?: string;
  priority?: string;
  photos?: string;
  is_critical?: boolean;
  status?: string;
  custom_fields?: Record<string, any>;
  fulfillment?: MaintenanceRequestFulfillmentPayload;
  work_detail?: MaintenanceRequestWorkDetailPayload;
  part_items?: MaintenanceRequestPartItemPayload[];
}

export const MAINTENANCE_REQUEST_FIELD_TO_INTERFACE_MAP: { [key: string]: string } = {
  'request_date': '',
  'asset_id': '',
  'form_template_id': '',

  // Computed Snapshot Values that backend expects
  'warranty_status': '',
  'amc_started': '',
  'next_maintenance_date': '',

  // Maintenance Details
  'request_type': '',
  'issue_type': '',
  'issue_description': '',
  'priority': '',
  'issue_photos': '',
  'is_critical': '',
};

/**
 * Read-only label fields that are displayed on the UI but should NOT be sent to the backend.
 * These are pre-filled from asset data and are for display only.
 */
export const MAINTENANCE_REQUEST_SKIP_FIELDS: string[] = [
  // Primary Information (Tab 1) - labels auto-filled from asset
  'asset_name',
  'asset_code',
  'serial_no',
  'model_no',
  'asset_tag',
  'asset_group',
  'asset_sub_group',
  'asset_type',
  'source_subsidiary_id',
  'source_location_id',
  'assigned_department_id',
  'sub_location_id',
  'assigned_person',
  'procurement_vendor_name',
  'parent_maintenance_request_id',
  // Warranty/AMC Details (Tab 2) - all labels from asset
  'warranty_copy',
  'warranty_expiry',
  'amc_copy',
  'amc_expiry',
  'insurance_policy_no',
  'insurance_expiry',
  'insurance_copy',
  'periodic_maintenance',
  'maintenance_period',
  'from_purchase',
  'continue_after_amc',
  'maintenance_type',
  'maintenance_schedule',
];
